import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminBusinessesContent from "../admin/components/AdminBusinessesContent";

const SupportOfficerBusinessPage = () => {
  return (
    <SupportLayout userRole="SO">
      <AdminBusinessesContent useOwnLayout={true} userRole="SO" />
    </SupportLayout>
  );
};

export default SupportOfficerBusinessPage;
